import { Injectable } from '@angular/core'
import { MbFeaturedProductAdapter } from './mb-featured-product.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbFeaturedProductConnector {

  constructor (protected adapter: MbFeaturedProductAdapter) {
  }

  get () {
    return this.adapter.load()
  }
}
